import * as React from 'react';
import { NotFound } from '../DocParts/NotFound';
import { translate } from 'react-i18next';
var InvoiceNotFound = function (_a) {
    var businessEmail = _a.businessEmail, businessName = _a.businessName, t = _a.t;
    return (React.createElement(NotFound, { messageText: t('invoice-view:invoice.not-found.message', {
            businessName: businessName,
            businessEmail: businessEmail,
        }), headerText: t('invoice-view:invoice.not-found.header') }));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(InvoiceNotFound);
//# sourceMappingURL=InvoiceNotFound.js.map